export function getTop(el: HTMLElement): number {
  let top = el.offsetTop;

  if (el.offsetParent) {
    top += getTop(el.offsetParent as HTMLElement);
  }

  return top;
}

export function getHeaderHeight(): number {
  const header = document.getElementById('medflow-header');
  if (header) {
    return header.getBoundingClientRect().height;
  }

  return 0;
}

export function scrollToWithStickyHeader(el: HTMLElement, offset = 0): void {
  const headerOffset = getHeaderHeight();

  window.scrollTo({
    top: getTop(el) - headerOffset - offset,
    behavior: 'smooth',
  });
}
